module.exports = __webpack_public_path__ + "static/media/screenshot.090d70b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/energy-bars/screenshot.jpg
// module id = 811
// module chunks = 0